















































































































































import {Component, Prop, Watch} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import Home from './home/home.vue'
import Basic from './basic.vue'
import Diagnosis from './diagnosis/diagnosis.vue'
import Road from './road'
import DialysisInfo from './dialysisInfo'
import OutCome from './outCome'
import DialysisPre from './dialysisPre'
import PatPna from './patPna'
import TreatmentAnalysis from './treatmentAnalysis'
import MissionInformation from './missionInformation'
import BloodRecord from './bloodRecord'
import CourseRecord from './courseRecord'
import Test from './test'
import BedRecord from './bedRecord'
import MedDocs from './medDocs'
import MedDoc from './medDoc'
import makeAdvice from './makeAdvice'
import assayResult from './assayResult'


@Component({
	components:{Home, Basic, Diagnosis, Road, DialysisInfo, OutCome, DialysisPre,
		PatPna, TreatmentAnalysis, MissionInformation, BloodRecord, CourseRecord,
		Test, BedRecord, MedDocs, MedDoc,makeAdvice,assayResult}
})
export default class PatientInfo extends AbpBase {
	@Prop({type:Boolean}) value :boolean
	@Prop() data :any
	tab = '1'
	theme = 'light'
	infoWidth = 1400
	//设备检测
	get detectmob() {
		if (navigator.userAgent.match(/Android/i)
			|| navigator.userAgent.match(/webOS/i)
			|| navigator.userAgent.match(/iPhone/i)
			|| navigator.userAgent.match(/iPad/i)
			|| navigator.userAgent.match(/iPod/i)
			|| navigator.userAgent.match(/BlackBerry/i)
			|| navigator.userAgent.match(/Windows Phone/i)
		) {
			return true;
		} else {
			return false;
		}
	}
	tabChange(val1:any,val2:any){
		this.tab = val1
	}

	get dialogTitle(){
		return this.data.patientName + "电子病历"
	}

	visibleChange(value: boolean) {
		if (!value) {
			this.$emit('input', value);
		}
	}
	mounted(){
		let width = document.body.offsetWidth
		this.infoWidth = width - 55 - 244
		console.log(width)
	}
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/patientInfo.vue